var BiometricSyntax_1;
import { __decorate } from "tslib";
import { id_pe, AlgorithmIdentifier } from "@peculiar/asn1-x509";
import { AsnProp, AsnPropTypes, AsnType, AsnTypeTypes, AsnArray, OctetString, } from "@peculiar/asn1-schema";
export const id_pe_biometricInfo = `${id_pe}.2`;
export var PredefinedBiometricType;
(function (PredefinedBiometricType) {
    PredefinedBiometricType[PredefinedBiometricType["picture"] = 0] = "picture";
    PredefinedBiometricType[PredefinedBiometricType["handwrittenSignature"] = 1] = "handwrittenSignature";
})(PredefinedBiometricType || (PredefinedBiometricType = {}));
let TypeOfBiometricData = class TypeOfBiometricData {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], TypeOfBiometricData.prototype, "predefinedBiometricType", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], TypeOfBiometricData.prototype, "biometricDataOid", void 0);
TypeOfBiometricData = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], TypeOfBiometricData);
export { TypeOfBiometricData };
export class BiometricData {
    constructor(params = {}) {
        this.typeOfBiometricData = new TypeOfBiometricData();
        this.hashAlgorithm = new AlgorithmIdentifier();
        this.biometricDataHash = new OctetString();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: TypeOfBiometricData })
], BiometricData.prototype, "typeOfBiometricData", void 0);
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], BiometricData.prototype, "hashAlgorithm", void 0);
__decorate([
    AsnProp({ type: OctetString })
], BiometricData.prototype, "biometricDataHash", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String, optional: true })
], BiometricData.prototype, "sourceDataUri", void 0);
let BiometricSyntax = BiometricSyntax_1 = class BiometricSyntax extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, BiometricSyntax_1.prototype);
    }
};
BiometricSyntax = BiometricSyntax_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: BiometricData })
], BiometricSyntax);
export { BiometricSyntax };
